import React from 'react';

import PageEditView from '../../../../scenes/PageEdit/components/PageEditView';
import { editorSection } from '../../pageEditTabs';

import EventDescriptionForm from './components/EventDescriptionForm';
import FormEditForm from './components/EventDetailsForm';
import EventDiscountsForm from './components/EventDiscountsForm';
import EventMediaForm from './components/EventMediaForm';
import EventTicketTypesForm from './components/EventTicketTypesForm';

export const getEventSections = ({ page, seller } = {}) => {
  const context = { page, seller };
  const section = path => editorSection('event', path, context);

  return [
    {
      ...section('/details'),
      description: 'Set your event title, dates, location, and attendance details.',
      helpUrl: '/docs/articles/create-an-event',
      component: <FormEditForm />,
    },
    {
      ...section('/description'),
      component: <EventDescriptionForm />,
      description: 'Add text, images, FAQs, and more to describe your event.',
    },
    {
      ...section('/image-gallery'),
      description: 'Add images to showcase your event.',
      component: <EventMediaForm />,
    },
    {
      ...section('/ticket-types'),
      description: 'Manage the tickets available for your event.',
      helpUrl: '/docs/articles/create-an-event',
      component: <EventTicketTypesForm />,
    },
    {
      ...section('/bulk-discounts'),
      description: 'Offer discounts based on the number of tickets purchased.',
      helpUrl: '/docs/articles/bulk-discounts-for-event-tickets',
      component: <EventDiscountsForm />,
    },
  ].filter(tab => tab.isVisible(context));
};

const PageEvent = () => {
  return <PageEditView tabs={getEventSections()} />;
};

export default PageEvent;
